import React from 'react';
import { useTranslation } from 'react-i18next';
import { appNamedRoutes } from 'routes';
import PageSubNav from 'components/nav/PageSubNav';

const CommunicationSubNav = () => {
  const { t } = useTranslation();
  const pages = [
    { path: appNamedRoutes.communicationIndividuals, label: t('communication.individuals') },
    { path: appNamedRoutes.communicationGroups, label: t('communication.groups') },
  ];
  return (
    <PageSubNav items={pages} />
  );
};

export default CommunicationSubNav;
